(function () {
    'use strict';
    angular.module('app').component('habilJustificationView', {
        templateUrl: '@/fvm/justification/justification-view.template.html',
        bindings: {
            branches: '<',
            justification: '=',
            organisationName: '<'
        },
        controller: JustificationController
    });

    JustificationController.$inject = ['$rootScope', 'justificationService', 'codesService'];
    function JustificationController($rootScope, justificationService, codesService) {
        const $controller = this;
        
        $controller.$onInit = function () {
            codesService.loadAllCodes(() => {
                $controller.codeCountries = $rootScope.codeCountries;
                $controller.codeAttachmentTypes = $rootScope.codeAttachmentTypes;
            });
        };

        $controller.GetAdditionalRemarks = () => $controller.justification && $controller.justification.Remarks ? $controller.justification.Remarks.filter(r => r.Section === '120') : [];

        $controller.GetType = () => justificationService.GetType($controller.justification);
        $controller.GetLevel = () => justificationService.GetLevel($controller.justification);

        $controller.dateWithMonthsDelay = dateWithMonthsDelay;
        function dateWithMonthsDelay(startDate, months) {
            const date = new Date(startDate);
            date.setMonth(date.getMonth() + months);
            return date;
        }

        $controller.compareDateStart = compareDateStart;
        function compareDateStart(startDate, months) {
            return dateWithMonthsDelay(startDate, months) < dateWithMonthsDelay(new Date(), 9);
        }

        $controller.compareDateStartEnd = compareDateStartEnd;
        function compareDateStartEnd(startDate, endDate) {
            return endDate <= startDate || endDate <= dateWithMonthsDelay(new Date(), 9);
        }
    }
})();